var map = {
	"./en/activity.json": 400,
	"./en/assetPriceGroups.json": 1123,
	"./en/assetRules.json": 74179,
	"./en/assetTypes.json": 83971,
	"./en/assets.json": 69226,
	"./en/auditLogs.json": 26289,
	"./en/auth.json": 31974,
	"./en/common.json": 83147,
	"./en/configurationSettings.json": 71028,
	"./en/customers.json": 34239,
	"./en/dashboard.json": 58205,
	"./en/devices.json": 58,
	"./en/inks.json": 51912,
	"./en/job-workflow.json": 34002,
	"./en/jobs.json": 57630,
	"./en/masterPackage.json": 52499,
	"./en/operations.json": 79420,
	"./en/orderProductStatus.json": 92647,
	"./en/orders.json": 57683,
	"./en/predefinedComments.json": 21882,
	"./en/quotes.json": 31659,
	"./en/roles.json": 596,
	"./en/sheets.json": 3778,
	"./en/shippingMethod.json": 31239,
	"./en/sign-in.json": 7754,
	"./en/siteAddresses.json": 59711,
	"./en/status.json": 78502,
	"./en/stores.json": 89510,
	"./en/template-management.json": 84162,
	"./en/users.json": 57154,
	"./fr/activity.json": 63024,
	"./fr/assetPriceGroups.json": 12693,
	"./fr/assetRules.json": 46954,
	"./fr/assetTypes.json": 12852,
	"./fr/assets.json": 80062,
	"./fr/auditLogs.json": 80665,
	"./fr/auth.json": 12459,
	"./fr/common.json": 97038,
	"./fr/configurationSettings.json": 17073,
	"./fr/customers.json": 21879,
	"./fr/dashboard.json": 22818,
	"./fr/devices.json": 12004,
	"./fr/inks.json": 68723,
	"./fr/job-workflow.json": 24822,
	"./fr/jobs.json": 95505,
	"./fr/masterPackage.json": 83697,
	"./fr/operations.json": 12202,
	"./fr/orderProductStatus.json": 11469,
	"./fr/orders.json": 76691,
	"./fr/predefinedComments.json": 78818,
	"./fr/quotes.json": 57869,
	"./fr/roles.json": 14319,
	"./fr/sheets.json": 5555,
	"./fr/shippingMethod.json": 8359,
	"./fr/sign-in.json": 37393,
	"./fr/siteAddresses.json": 9322,
	"./fr/status.json": 87783,
	"./fr/stores.json": 88138,
	"./fr/template-management.json": 4606,
	"./fr/users.json": 52332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33328;